export default {
  fields: {
    receiverName: "收貨人姓名：",
    phone: "聯繫手機：",
    address: "收貨地址：",
    quantity: "數量：",
    time: "時間：",
  },
  common: {
    empty: "暫無數據",
  },
};
